import { gql } from '@apollo/client';

export const IS_USAGE_LIMIT_EXCEEDED = gql`
  query IsUsageLimitExceeded($filter: IsUsageLimitExceededFilterInput!) {
    isUsageLimitExceeded(filter: $filter) {
      allowed
      reason
      casesLeft
      pipelineRunsLeft
      dueDiligenceLeft
      nextRenewalDate
    }
  }
`;
